<template lang="pug">
v-card.pl-3.mb-3.elevation-2
  v-layout(align-center, justify-space-between)
    div
      v-icon.mr-2 fa fa-paperclip
      b {{ file.name }}

    div
      v-btn(@click='downloadFile', icon)
        v-icon(color='primary') fa fa-download

      v-btn(@click='removeFile', icon)
        v-icon(color='error') fa fa-trash-alt
</template>

<script>
export default {
  name: 'File',

  props: {
    file: Object
  },

  methods: {
    removeFile () {
      this.$emit('remove', this.file)
    },

    async downloadFile () {
      this.$store.dispatch('files/download', {
        url: this.file.url,
        name: this.file.name
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
